export default "__VITE_ASSET__3zPeUme0__"